import type { SVGProps } from 'react';
const DawnFlagUG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-UG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-UG_svg__a)">
      <path fill="#262626" d="M0 2.133h22V0H0zM0 10.667h22V8.533H0z" />
      <path fill="#ED1623" d="M0 8.533h22v-3.2H0z" />
      <path fill="#FEE044" d="M0 5.333h22v-3.2H0z" />
      <path fill="#ED1623" d="M0 16h22v-2.133H0z" />
      <path fill="#FEE044" d="M0 13.867h22v-3.2H0z" />
      <path
        fill="#fff"
        d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
      />
      <path
        fill="#262626"
        d="M10.182 6.1a.333.333 0 0 1 0-.467l.275-.28.035-.041c.02-.025.053-.07.096-.117.162-.179.735-.142.878.053.067.09.028.147-.022.248l-.41.834a.3.3 0 0 0-.034.147v.252c0 .125.07.24.182.297l.817.416a.3.3 0 0 1 .087.063l.844.86c.099.1.124.253.061.38l-.228.465a.308.308 0 0 1-.496.08.31.31 0 0 0-.439 0l-.208.213a.33.33 0 0 0-.096.233v.288c0 .07.028.137.077.187a.268.268 0 0 1-.191.456h-.296a.268.268 0 0 1-.19-.456.27.27 0 0 0 .076-.187v-.09a.333.333 0 0 0-.333-.334h-.05a.33.33 0 0 0-.239.1l-.188.191a.333.333 0 0 1-.475 0l-.057-.057a.333.333 0 0 1 0-.468l.197-.2a.33.33 0 0 1 .237-.1h.114a.333.333 0 0 0 .237-.566l-.785-.8a.333.333 0 0 1 0-.467l.589-.6a.333.333 0 0 0 0-.467z"
      />
    </g>
  </svg>
);
export default DawnFlagUG;
